<div>
  <mat-table
    matSort
    [dataSource]="draftInteractionsList"
    (matSortChange)="onSortChange($event)"
    class="medis-table medis-pt-10"
  >
    <ng-container matColumnDef="view-details">
      <mat-header-cell *matHeaderCellDef class="mat-cell-40-fixed"></mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-40-fixed"
      >
        <i
          class="fas fa-sign-in-alt view-interaction-details-icon"
          [class.view-interaction-details-icon-hovered]="
            hoveredInteractionPk === draftInteraction.pk()
          "
        ></i>
        <div
          *ngIf="hoveredInteractionPk === draftInteraction.pk()"
          class="interaction-simulated-tooltip"
        >
          {{ 'VIEW_DRAFT_INTERACTION_DETAILS' | translate }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef class="mat-cell-70">
        <div mat-sort-header>{{ 'DRAFT' | translate }} {{ 'ID' | translate }}</div>
        <mat-form-field (click)="$event.stopPropagation()" class="form-field-wrapper fs-10">
          <input
            matInput
            autocomplete="off"
            type="number"
            numbersOnly
            (keyup)="triggerSearch()"
            [(ngModel)]="searchedId"
          />
        </mat-form-field>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-70"
      >
        {{ draftInteraction | pk }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="inquirer">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'INQUIRER' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="inquirerConfig"
          [multiple]="true"
          [(selectedValue)]="searchedInquirerIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.inquirer.id"
          matTooltip="{{ draftInteraction.inquirer | displayInfo }}"
          class="truncated-text"
        >
          {{ draftInteraction.inquirer | displayInfo }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="team">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'TEAM' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="teamConfig"
          [multiple]="true"
          [(selectedValue)]="searchedTeamIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        class="mat-cell-100"
      >
        <div
          *ngIf="!draftInteraction.isInlineEdit"
          matTooltip="{{ draftInteraction?.team?.name }} | {{ 'ENABLE_INLINE_EDIT' | translate }}"
          class="truncated-text"
        >
          {{ draftInteraction?.team?.name }}
        </div>
        <app-reassign
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority"
          [style]="'inline-edit'"
          [mode]="'teams'"
          [isDraft]="true"
          [skipConfirmation]="true"
          [selectedItems]="[draftInteraction]"
          [selectedTeamId]="selectedTeamId"
          (reassign)="onReassign()"
        ></app-reassign>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="topic">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'TOPIC' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="topicConfig"
          [multiple]="true"
          [(selectedValue)]="searchedTopicIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        [matTooltipDisabled]="
          (draftInteraction.topicList !== '' && !draftInteraction.isInlineEdit) ||
          draftInteraction.isInlineEdit
        "
        matTooltip="{{ 'ENABLE_INLINE_EDIT' | translate }}"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.topicList !== '' && !draftInteraction.isInlineEdit"
          matTooltip="{{ draftInteraction.topicList }} | {{ 'ENABLE_INLINE_EDIT' | translate }}"
          class="truncated-text"
        >
          {{ draftInteraction.topicList }}
        </div>
        <app-search-select
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority"
          [config]="metadata.topicConfig"
          [style]="'inline-edit'"
          [(selectedValue)]="metadata.selectedTopic"
          (selectedValueChange)="setTopicRelated(draftInteraction)"
          [required]="true"
        ></app-search-select>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="category">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'CATEGORY' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="categoryConfig"
          [multiple]="true"
          [(selectedValue)]="searchedCategoryIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        [matTooltipDisabled]="
          (draftInteraction.categoryList !== '' && !draftInteraction.isInlineEdit) ||
          draftInteraction.isInlineEdit
        "
        matTooltip="{{ 'ENABLE_INLINE_EDIT' | translate }}"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.categoryList !== '' && !draftInteraction.isInlineEdit"
          matTooltip="{{ draftInteraction.categoryList }} | {{ 'ENABLE_INLINE_EDIT' | translate }}"
          class="truncated-text"
        >
          {{ draftInteraction.categoryList }}
        </div>
        <app-search-select
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority"
          [config]="metadata.categoryConfig"
          [style]="'inline-edit'"
          [(selectedValue)]="metadata.selectedCategory"
          (selectedValueChange)="setTopicRelated(draftInteraction)"
          [required]="true"
        ></app-search-select>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="product">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'PRODUCT' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="productConfig"
          [multiple]="true"
          [(selectedValue)]="searchedProductIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        [matTooltipDisabled]="
          (draftInteraction.productList !== '' && !draftInteraction.isInlineEdit) ||
          draftInteraction.isInlineEdit
        "
        matTooltip="{{ 'ENABLE_INLINE_EDIT' | translate }}"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.productList !== '' && !draftInteraction.isInlineEdit"
          matTooltip="{{ draftInteraction.productList }} | {{ 'ENABLE_INLINE_EDIT' | translate }}"
          class="truncated-text"
        >
          {{ draftInteraction.productList }}
        </div>
        <app-search-select
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority"
          [config]="metadata.productConfig"
          [style]="'inline-edit'"
          [(selectedValue)]="metadata.selectedProduct"
          (selectedValueChange)="setTopicRelated(draftInteraction)"
          [required]="true"
        ></app-search-select>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="insertedBy">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'INSERTED_BY' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="insertedByConfig"
          [multiple]="true"
          [(selectedValue)]="searchedInsertedByIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.insertedBy"
          matTooltip="{{ draftInteraction.insertedBy | displayInfo }}"
          class="truncated-text"
        >
          {{ draftInteraction.insertedBy | displayInfo }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="assignedTo">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'ASSIGNED_TO' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="assignedToConfig"
          [multiple]="true"
          [(selectedValue)]="searchedAssignedToIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        [matTooltipDisabled]="draftInteraction.assignedTo || draftInteraction.isInlineEdit"
        matTooltip="{{ 'ENABLE_INLINE_EDIT' | translate }}"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.assignedTo && !draftInteraction.isInlineEdit"
          matTooltip="{{ draftInteraction.assignedTo | displayInfo }} | {{
            'ENABLE_INLINE_EDIT' | translate
          }}"
          class="truncated-text"
        >
          {{ draftInteraction.assignedTo | displayInfo }}
        </div>
        <app-reassign
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority"
          [style]="'inline-edit'"
          [mode]="'users'"
          [isDraft]="true"
          [skipConfirmation]="true"
          [selectedItems]="[draftInteraction]"
          [selectedUser]="selectedUser"
          (reassign)="onReassign()"
        ></app-reassign>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="language">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'LANGUAGE' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="languageConfig"
          [multiple]="true"
          [(selectedValue)]="searchedLanguageIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-100"
      >
        <div [matTooltip]="draftInteraction?.language?.name" class="truncated-text">
          {{ draftInteraction?.language?.name }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="event">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'Event' | translate }}</div>
        <app-search-select
          [style]="'fs-10'"
          [config]="eventConfig"
          [multiple]="true"
          [(selectedValue)]="searchedEventIds"
          (selectedValueChange)="triggerSearch()"
        ></app-search-select>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        [matTooltipDisabled]="draftInteraction.event.id || draftInteraction.isInlineEdit"
        matTooltip="{{ 'ENABLE_INLINE_EDIT' | translate }}"
        class="mat-cell-100"
      >
        <div
          *ngIf="draftInteraction.event.id && !draftInteraction.isInlineEdit"
          matTooltip="{{ draftInteraction.event.name }} | {{ 'ENABLE_INLINE_EDIT' | translate }}"
          class="truncated-text"
        >
          {{ draftInteraction.event.name }}
        </div>
        <app-search-select
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority"
          [config]="inlineEditEventConfig"
          [style]="'inline-edit'"
          [(selectedValue)]="selectedEventId"
          (selectedValueChange)="setEvent($event, draftInteraction)"
        ></app-search-select>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdTs">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'CREATED_ON' | translate }}</div>
        <app-date-time-picker
          [enableReset]="true"
          [timeZone]="'UTC'"
          [(value)]="searchedCreatedTs"
          (valueChange)="triggerSearch()"
        ></app-date-time-picker>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-100"
      >
        <div [matTooltip]="draftInteraction.createdTs | dateChecker" class="truncated-text">
          {{ draftInteraction.createdTs | dateCheckerNoHour }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="dueDate">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'DUE_DATE' | translate }}</div>
        <app-date-time-picker
          [enableReset]="true"
          [timeZone]="'UTC'"
          [(value)]="searchedDueDate"
          (valueChange)="triggerSearch()"
        ></app-date-time-picker>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-100"
      >
        <div [matTooltip]="draftInteraction.dueDate | dateChecker" class="truncated-text">
          {{ draftInteraction.dueDate | dateCheckerNoHour }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="priority">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div mat-sort-header>{{ 'PRIORITY' | translate }}</div>
        <mat-form-field (click)="$event.stopPropagation()" class="form-field-wrapper fs-10">
          <mat-select
            [(ngModel)]="searchedPriority"
            (ngModelChange)="triggerSearch()"
            [ngClass]="{ 'not-empty': searchedPriority }"
            [attr.data-testid]="'reset-fields-priority-section'"
          >
            <mat-option [value]="''" class="priority-show-all">
              <span class="priority-icon">{{ 'Show_all' | translate }}</span>
            </mat-option>
            <mat-option *ngFor="let priority of priorities" [value]="priority">
              <div class="medis-flex-container-between">
                <span class="priority-icon" [ngClass]="priority.toLowerCase() + '_priority_icon'">{{
                  priority | translate
                }}</span>
                <i *ngIf="priority === searchedPriority" class="fa fa-check"></i>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-header-cell>

      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        class="mat-cell-100"
      >
        <div
          *ngIf="!draftInteraction.isInlineEdit"
          [ngClass]="draftInteraction.priority + '_priority_icon'"
          matTooltip="{{ draftInteraction.priority | uppercase }} | {{
            'ENABLE_INLINE_EDIT' | translate
          }}"
          class="truncated-text priority-icon"
        >
          {{ draftInteraction.priority }}
        </div>
        <mat-form-field
          *ngIf="draftInteraction.isInlineEdit"
          class="form-priority form-field-wrapper inline-edit"
          (click)="$event.stopPropagation()"
        >
          <mat-label class="header-cell">{{ 'PRIORITY' | translate }}</mat-label>
          <mat-select
            class="not-empty"
            [(ngModel)]="selectedPriority"
            (ngModelChange)="setPriority($event, draftInteraction)"
          >
            <mat-option *ngFor="let priority of priorities" [value]="priority">
              <div class="medis-flex-container-between">
                <span class="priority-icon" [ngClass]="priority.toLowerCase() + '_priority_icon'">{{
                  priority | translate
                }}</span>
                <i *ngIf="priority === selectedPriority" class="fa fa-check"></i>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="isPublic">
      <mat-header-cell *matHeaderCellDef class="mat-cell-120-fixed">
        <div mat-sort-header>{{ 'PUBLIC' | translate }}</div>
        <mat-button-toggle-group
          class="table-header-3-even-toggles icon-toggles"
          [(value)]="searchedIsPublic"
          (valueChange)="triggerSearch()"
        >
          <mat-button-toggle value="all" matTooltip="{{ 'ALL' | translate }}">
            <i class="fas fa-list medis-icon ms-0"></i>
          </mat-button-toggle>
          <mat-button-toggle value="1" matTooltip="{{ 'YES' | translate }}">
            <i class="fas fa-check-circle medis-icon-active ms-0"></i>
          </mat-button-toggle>
          <mat-button-toggle value="0" matTooltip="{{ 'NO' | translate }}">
            <i class="fas fa-times-circle medis-icon-inactive ms-0"></i>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction; let index = index"
        (click)="$event.stopPropagation(); activateInlineEdit(index)"
        class="mat-cell-120-fixed"
      >
        <div
          *ngIf="!draftInteraction.isInlineEdit || selectedEventId"
          [ngClass]="draftInteraction.isPublic ? 'is-positive' : 'is-negative'"
          matTooltip="{{ (draftInteraction.isPublic ? 'IS_PUBLIC' : 'IS_PRIVATE') | translate }} {{
            draftInteraction.event.id ? '' : ' | ' + ('ENABLE_INLINE_EDIT' | translate)
          }}"
          class="administration-section-list-statuses yes-or-no-label truncated-text"
        >
          {{ (draftInteraction.isPublic ? 'YES' : 'NO') | translate }}
        </div>
        <mat-form-field
          *ngIf="draftInteraction.isInlineEdit && !selectedEventId"
          class="form-priority form-field-wrapper inline-edit"
          (click)="$event.stopPropagation()"
        >
          <mat-label class="header-cell">{{ 'PUBLIC' | translate }}</mat-label>
          <mat-select
            class="not-empty"
            [(ngModel)]="selectedIsPublic"
            (ngModelChange)="setPublic($event, draftInteraction)"
          >
            <mat-option *ngFor="let isPublic of isPublicChoices" [value]="isPublic">
              {{ (isPublic ? 'YES' : 'NO') | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef class="mat-cell-100">
        <div class="header-text">{{ 'TITLE' | translate }}</div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let draftInteraction"
        (mouseenter)="hoveredInteractionPk = draftInteraction.pk()"
        (mouseleave)="hoveredInteractionPk = null"
        class="mat-cell-100"
      >
        <div [matTooltip]="draftInteraction.title" class="truncated-text">
          {{ draftInteraction.title }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef class="mat-cell-60">
        <div class="header-text">{{ 'DELETE' | translate }}</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let draftInteraction" class="mat-cell-60">
        <i
          matTooltip="{{ 'DELETE_INTERACTION' | translate }}"
          (click)="$event.stopPropagation(); deleteDraftInteraction(draftInteraction)"
          class="fas fa-trash-alt medis-icon"
        ></i>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="statusIndicator">
      <mat-header-cell *matHeaderCellDef>
        <app-loading-indicator [loading]="loading" [empty]="!totalRecords"></app-loading-indicator>
      </mat-header-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-header-row
      *matHeaderRowDef="['statusIndicator']; sticky: true"
      [class.medis-not-displayed]="draftInteractionsList.length !== 0 && !loading"
    ></mat-header-row>

    <mat-row
      *matRowDef="let draftInteraction; columns: displayedColumns"
      (click)="$event.stopPropagation(); interactionDetailUrl(draftInteraction)"
      class="cursor-pointer position-relative"
    >
    </mat-row>
  </mat-table>
</div>

<app-paginated-navbar
  *ngIf="totalRecords"
  [pagesCount]="totalRecords"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [pageIndex]="pageIndex"
  (pageChange)="onPageChange($event)"
></app-paginated-navbar>
